import { createAction } from "redux-actions";

export const toggleBoxShadow = createAction("TOGGLE_BOX_SHADOW");
export const toggleTopNavigation = createAction("TOGGLE_TOP_NAVIGATION");
